import * as React from 'react'
import {compose} from 'redux'
import { Field, reduxForm} from 'redux-form'
import Grid from '@material-ui/core/Grid/Grid'
import {TextField, RadioGroup} from 'redux-form-material-ui'
import autobind from 'autobind-decorator'
import {change} from 'redux-form'
import {connect} from 'react-redux'
import { Validator } from 'src/core/form/Validator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import GeosuggestInput from 'src/shared/Autocomplete/GeosuggestInput'
import { FormControlLabel, Radio, Typography, Tooltip, Icon } from '@material-ui/core'
import { generateAdresseFormObj } from 'src/shared/utils/helpers'

interface IProps extends WithI18n,
  ReturnType<typeof dispatch2props>{
  handleSubmit: () => void;
  initialValues: any;
}

const validate = values => Validator.build(values, {
  person_to_notify_email: [Validator.email, Validator.required],
  person_to_notify_first_name: [Validator.required],
  person_to_notify_last_name: [Validator.required],
  street: [Validator.required],
  zip: [Validator.required],
  city: [Validator.required],
  country: [Validator.required],
  emir_status: [Validator.required],
  siren: [Validator.siren]
});

class InformationContractualForm extends React.Component<IProps>{

  render(){
    const { handleSubmit, t, initialValues} = this.props;
    return (
      <>
        <form style={{marginTop: 16}} onSubmit={handleSubmit}>
            
            <div><br/></div>
            <Typography variant="subtitle2" gutterBottom>{t.EnterpriseDetail_info_contractual_person_to_notify}</Typography>
            <Grid container style={{padding: '1rem'}}>
              <Grid item xs={4}>
                <Field
                  name="person_to_notify_first_name"
                  component={TextField}
                  label={t.firstName}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={4}>
                <Field
                  name="person_to_notify_last_name"
                  component={TextField}
                  label={t.lastName}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={4}>
                <Field
                  name="person_to_notify_email"
                  component={TextField}
                  label={t.email}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={12}>
                  <GeosuggestInput
                      label={t.address}
                      placeholder={(initialValues && initialValues.person_to_notify_address) ? generateAdresseFormObj(initialValues.person_to_notify_address) : t.address}
                      onPlaceChanged={this.getAddress}
                  />
              </Grid>
              <Grid item xs={12} md={2}>
                  <Field
                      name="number"
                      fullWidth={true}
                      label="Numéro"
                      component={TextField}
                      />
              </Grid>
              <Grid item xs={12} md={4}>
                  <Field
                      name="street"
                      fullWidth={true}
                      label="Rue"
                      component={TextField}
                  />
              </Grid>
              <Grid item xs={12} md={2}>
                  <Field
                      name="zip"
                      fullWidth={true}
                      label="Code postal"
                      component={TextField}
                  />
              </Grid>
              <Grid item xs={12} md={2}>
                  <Field
                      name="city"
                      fullWidth={true}
                      label="Ville"
                      component={TextField}
                  />
              </Grid>
              <Grid item xs={12} md={2}>
                  <Field
                      name="country"
                      fullWidth={true}
                      label="Pays"
                      component={TextField}
                  />
              </Grid>
            </Grid>
            <div><br/></div>
            <Typography variant="subtitle2" gutterBottom>{t.EnterpriseDetail_info_contractual_status_emir}</Typography>
            <Grid container style={{padding: '1rem'}}>
              <Grid item xs={12}>
                <Field
                    name="emir_status"
                    component={RadioGroup}
                >
                    <Typography variant="body2" style={{fontStyle: 'italic'}} gutterBottom>Vous déclarez et attestez être une</Typography>
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_third_option}
                        control={<Radio color="primary" />}
                        label={
                          <>
                            {t.EnterpriseDetail_info_contractual_status_emir_third_option}
                            <Tooltip title={this.emirTooltipRender()} placement="top">
                              <Icon style={{fontSize: '15px', color: '#9e9e9e', marginLeft: '4px'}}>info</Icon>
                            </Tooltip>
                          </>
                        }
                    />
                    <br/>
                    <Typography variant="body2" style={{fontStyle: 'italic'}} gutterBottom>Sauf si vous cochez l’une des cases suivantes :</Typography>
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_first_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_first_option}
                    />
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_second_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_second_option}
                    />
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_fourth_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_fourth_option}
                    />
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_fifth_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_fifth_option}
                    />
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_sixth_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_sixth_option}
                    />
                    <FormControlLabel
                        value={t.EnterpriseDetail_info_contractual_status_emir_seventh_option}
                        control={<Radio color="primary" />}
                        label={t.EnterpriseDetail_info_contractual_status_emir_seventh_option}
                    />
                </Field>
            </Grid>
            </Grid>
            <Grid container style={{padding: '0 1rem 1rem 1rem'}}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>{t.EnterpriseDetail_info_contractual_lei}</Typography>
                <Field
                    name="lei"
                    component={TextField}
                    label={t.EnterpriseDetail_info_general_lei}
                    fullWidth={true}
                />
              </Grid>
            </Grid>
        </form>
      </>
    )
  }

  componentDidMount(){
    const {initialValues, changeField, t} = this.props
    if(initialValues){
      changeField('city', initialValues.person_to_notify_address.city);
      changeField('zip', initialValues.person_to_notify_address.zip);
      changeField('country', initialValues.person_to_notify_address.country);
      changeField('street', initialValues.person_to_notify_address.street);
      changeField('number', initialValues.person_to_notify_address.number);
    } else {
      changeField('emir_status', t.EnterpriseDetail_info_contractual_status_emir_third_option);
    }
  }

  @autobind
  private emirTooltipRender(){
    return (
      <div style={{minWidth: '200px'}}>
        Cela signifie que vous détenez des positions en dessous de tous les seuils de compensation : <br/>
          <Icon style={{fontSize: 6}}>brightness_1</Icon> moins de 1 milliard d'euros sur les dérivés de crédit et, <br/>
          <Icon style={{fontSize: 6}}>brightness_1</Icon> moins de 1 milliard d'euros sur les dérivés actions et, <br/>
          <Icon style={{fontSize: 6}}>brightness_1</Icon> moins de 3 milliards d'euros sur les dérivés de taux et, <br/>
          <Icon style={{fontSize: 6}}>brightness_1</Icon> moins de 3 milliards d'euros sur les dérivés de change et, <br/>
          <Icon style={{fontSize: 6}}>brightness_1</Icon> moins de 3 milliards d'euros sur les dérivés sur matières premières et autres. <br/>
      </div>
    )
  }

  @autobind
  private getAddress(place){
    const { changeField, initialValues } = this.props;
    changeField('city', place.locality);
    changeField('zip', place.postal_code);
    changeField('country', place.country);
    changeField('street', place.route);
    changeField('number', place.street_number);
    if (!place.route) {
      changeField('street', place.colloquial_area);
      if (initialValues.person_to_notify_address.number) {
        changeField("number", " ");
      }
    }
  }
}

const dispatch2props = dispatch => ({
  changeField: (field, value) => dispatch(change('informationContractualForm', field, value))
});

export default compose(
  withI18n,
  connect(null, dispatch2props)
)(reduxForm({
  form: 'informationContractualForm',
  validate
})(InformationContractualForm))



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/forms/InformationContractualForm.tsx